<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: 'Workspace'})"/>
                {{ $t('health.recipe.title') }}
              </h1>
              <div class="header-add-button">
                <span
                  v-has-feature="'Ring'"
                  v-tooltip.left.top-start="$t('health.recipe.glucoRecipes')"
                  @click="$router.push({name: 'RecipeListNonEditable'})"
                >
                            <font-awesome-icon
                              class="header-add-button-icon"
                              :icon="icon.list"/>
                 </span>

                <span
                      v-tooltip.left.top-start="$t('health.nutritionalPlan.addIngest')"
                      @click="createRecipe"
                  >
                    <font-awesome-icon
                        class="header-add-button-icon"
                        :icon="icon.add"/>
                  </span>
              </div>
            </div>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="recipeTable"
              :data="fetchData"
              sort-by="name"
              sort-order="asc"
              :show-caption="false"
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <table-column
                show="id"
                :hidden="true"
                :filterable="false"
                data-type="boolean">
              </table-column>
              <table-column
                show="name"
                :label="$t('health.patient.name')"
                header-class="text-left"
                cell-class="table-component__text-left">
              </table-column>

              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="editRecipe(row)"
                    :icon="icon.edit"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
              <table-column
                label=""
                :sortable="false"
                :filterable="false"
                header-class="table-component__minimum__width__column"
                cell-class="text-center">
                <template slot-scope="row">
                  <font-awesome-icon
                    v-on:click="removeRecipe(row)"
                    :icon="icon.remove"
                    class="table-iconset-icon"/>
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
      <ok-cancel-modal
        v-if="showConfirmationDeleteModal"
        v-on:ok="onDeleteConfirm"
        v-on:cancel="onDeleteCancel"
        :title="deleteModalMessage"
        :message="deleteModalMessage"
        :okButton="$t('commons.delete')"
        :cancelButton="$t('commons.cancel')">
        <div slot="body">
          <ul>
            <li>
              {{ recipeToDelete.name }}
            </li>
          </ul>
        </div>
      </ok-cancel-modal>

    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import pagination from '@/components/shared/table/pagination';
import Chevron from '@/components/shared/Chevron';
import OkCancelModal from '@/components/shared/dialogs/OkCancelModal';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faPencilAlt, faTrashAlt, faList} from '@fortawesome/pro-regular-svg-icons';
import api from 'BRAND/api/recipe';
import {faPlusCircle} from '@fortawesome/pro-solid-svg-icons';
import {mapGetters} from 'vuex';
import SafeRouterLink  from "../../../../components/shared/SafeRouterLink.vue";

export default {
  name: 'RecipeList',
  components: {
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    Chevron,
    OkCancelModal,
    SafeRouterLink
  },
  data () {
    return {
      recipes: [],
      selectedUser: null,
      showUserModal: false,
      breadcrumb: [
        {link: '/workspace', name: this.$t('menu.workspace')},
        {link: '/recipe', name: this.$t('health.recipe.title'), disabled: true}
      ],
      icon: {
        add: faPlusCircle,
        remove: faTrashAlt,
        edit: faPencilAlt,
        list: faList
      },
      /* Alert */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success'
      showConfirmationDeleteModal: false,
      recipeToDelete: undefined,
      deleteModalMessage: '',
      /* Table */
      tablePageSize: 10,
      tableState: {
        filter: '',
        page: 1,
        sort: {
          order: '',
          fieldName: ''
        }
      }
    };
  },
  mounted () {
    this.requestRecipes();
  },
  computed: {
    ...mapGetters([
      'getLanguageCode',
      'getUserAccount'
    ]),
    getBreadcrumb () {
      return this.breadcrumb;
    },
    getRecipes () {
      return this.recipes;
    },
    isNutritionist() {
      const account = this.getUserAccount;
      if (!account || !account.authorities) return false;
      return account.authorities.includes('ROLE_PRESCRIPTOR');
    }
  },
  methods: {
    fetchData ({page, filter, sort}) {
      const tablePage = pagination.createPage(
        this.getRecipes,
        this.tableState,
        ['name'],
        this.tablePageSize,
        {page, filter, sort});
      this.tableState = tablePage.state;
      return tablePage.result;
    },
    requestRecipes() {
      const languageCode = this.getLanguageCode;
      const apiCall = this.isNutritionist
        ? api.getRecipesByNutritionist(this, languageCode)
        : api.getRecipes(this, languageCode);

      apiCall
        .then((response) => {
          this.recipes = response;
          this.$refs.recipeTable.refresh();
        })
        .catch((error) => {
          this.alertVisible = true;
          this.alertMessage = error;
          this.alertType = 'error';
        });
    },
    onDeleteConfirm () {
      api.removeRecipe(this, this.recipeToDelete.id)
        .then(() => {
          this.requestRecipes();
          this.showConfirmationDeleteModal = false;
        })
        .catch((error) => {
          this.alertVisible = true;
          this.alertMessage = error;
          this.alertType = 'error';
        });
    },
    onDeleteCancel () {
      this.showConfirmationDeleteModal = false;
      this.recipeToDelete = undefined;
      this.deleteModalMessage = '';
    },
    createRecipe () {
      this.$router.push({name: 'EditRecipe', params: {mode: 'create', user:this.getUserAccount}});
    },
    editRecipe (row) {
      console.log('id:', row.id);
      this.$router.push({name: 'EditRecipe', params: {id: row.id, mode: 'edit', user:this.getUserAccount}});
    },
    removeRecipe (row) {
      this.recipeToDelete = row;
      this.deleteModalMessage = this.$t('health.recipe.delete');
      this.showConfirmationDeleteModal = true;
    },

  }
};

</script>

<style lang="scss" >
@import "src/stylesheets/variables";

#header {
  display: inline-block;
  width: 100%;
  line-height: 1rem;
}
.header-title {
  float: left;
}
.header-add-button {
  float: right;
}
.header-add-button-icon {
  font-size: 3rem;
  color: $secondary;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/recipe/RecipeList.vue